// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__13dOT","footer":"ModalFilter_footer__1Rv_p"};